import apiApp from "./index";

const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
        const subTenantId = decodedToken?.subTenantId;
        return subTenantId ? `&subTenantId=${subTenantId}` : "";
    } else if (switched && switchedSubtenant) {
        return `&subTenantId=${switchedSubtenant?.id}`;
    }
    return "";
};

// Helper: build subTenantDTO for request body
const getSubTenantDTO = () => {
  return decodedToken?.isMultitenancy && decodedToken?.subTenantId
    ? { id: decodedToken.subTenantId }
    : null;
};

// Common headers with conditional tenant-login
const getHeaders = () => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-Authorization": decodedToken?.tenantApiKey,
  };

  if (decodedToken?.roles?.includes("TENANT_ADMIN") || decodedToken?.subTenantId === undefined) {
    headers["tenant-login"] = true;
  }

  return headers;
};

const DesignationApi = {
  // Create Designation
  CreateDesignation: (data) => {
    const jsonData = JSON.parse(data);
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;

    return apiApp
      .post(`/designations`, JSON.stringify(jsonData), { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // List Designations
  ListDesignation: (page, limit) => {
    const url =
      page === undefined || limit === undefined
        ? `/designations?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`
        : `/designations?page=${page}&size=${limit}&sort=desc&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`;

    return apiApp
      .get(url, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Single Designation
  SingleDesignation: (designationId) => {
    return apiApp
      .get(
        `/designations/${designationId}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Update Designation
  PutDesignation: (designationId, data) => {
    const jsonData = JSON.parse(data);
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;

    return apiApp
      .put(`/designations/${designationId}`, JSON.stringify(jsonData), { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Delete Designation
  DeleteDesignations: (designationId) => {
    return apiApp
      .delete(
        `/designations/${designationId}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },
};

export default DesignationApi;
